import { injectGlobal } from 'styled-components';

injectGlobal`
    body {
        color: black;
        font-size: 14px;
        font-family: 'Platform-Light', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    @font-face {
        font-family: 'Platform-Regular';
        src: url(/${require('../assets/fonts/Platform-Regular.otf')});
    }


    @font-face {
        font-family: 'Platform-Light';
        src: url(/${require('../assets/fonts/Platform-Light.otf')});
    }

    @font-face {
        font-family: 'Platform-Medium';
        src: url(/${require('../assets/fonts/Platform-Medium.otf')});
    }

    @font-face {
        font-family: 'TiemposText-Bold';
        src: url(/${require('../assets/fonts/TiemposTextWeb-Bold.woff')});
    }

    @font-face {
        font-family: 'TiemposText-BoldItalic';
        src: url(/${require('../assets/fonts/TiemposTextWeb-BoldItalic.woff')});
    }

    @font-face {
        font-family: 'TiemposText-Regular';
        src: url(/${require('../assets/fonts/TiemposTextWeb-Regular.woff')});
    }

    @font-face {
        font-family: 'TiemposText-RegularItalic';
        src: url(/${require('../assets/fonts/TiemposTextWeb-RegularItalic.woff')});
    }
`




// WEBPACK FOOTER //
// ./client/styles/fonts.js